document.querySelectorAll(".switch_layout_inner").forEach(function(element) {
    element.addEventListener("click", function() {
        var data_handle = this.getAttribute("data-handle");
        var productGrid = document.getElementById("product-grid");
document.querySelectorAll(".switch_layout_inner").forEach(function(innerItem) {
            innerItem.classList.remove("active");
        });
        this.classList.add("active");
        if (data_handle == 'listed') {
            productGrid.classList.add("grid--2-col-desktop");
            productGrid.classList.remove("grid--4-col-desktop");
        } else {
            productGrid.classList.add("grid--4-col-desktop");
            productGrid.classList.remove("grid--2-col-desktop");
        }
    });
});
document.addEventListener('change', function(event) {
    if (event.target.closest('.sort_by-main-wrapper .input_label_outer-wrapper .input-label-rpeater-data input')) {
        document.querySelector('.custom-sort_by_filter').classList.remove("mob-sort-active");
        var loc = window.location.href;
        var sortOption = event.target.value;
        var incStr = loc.includes("sort_by");
        var ques = loc.includes("?");
        var previousOption = document.getElementById('SortBy-mobile').value;
        var optName = document.getElementById('SortBy-mobile').getAttribute('name');
        var sectionid = document.querySelector('aside').getAttribute('data-id');
        var collectionContent;

        if (incStr && ques) {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc.replace('sort_by=' + previousOption, 'sort_by=' + sortOption);
            console.log(window.location.pathname + '?section_id=' + sectionid + '&' + optName + '=' + sortOption);
            fetch(window.location.pathname + '?section_id=' + sectionid + '&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
                  var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  method: 'scroll',
  offset: 1000
});
                  var data_handle = document.querySelector(".switch_layout_inner.active").getAttribute("data-handle");
var productGrid = document.getElementById("product-grid");
if (data_handle == 'listed') {
productGrid.classList.add("grid--2-col-desktop");
productGrid.classList.remove("grid--4-col-desktop");
} 
else{
productGrid.classList.add("grid--4-col-desktop");
productGrid.classList.remove("grid--2-col-desktop");
}
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        } else if (incStr && !ques) {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc.replace('sort_by=' + previousOption, 'sort_by=' + sortOption);
            fetch(window.location.pathname + '?section_id=' + sectionid + '&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
                  var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  method: 'scroll',
  offset: 1000
});
                  var data_handle = document.querySelector(".switch_layout_inner.active").getAttribute("data-handle");
var productGrid = document.getElementById("product-grid");
if (data_handle == 'listed') {
productGrid.classList.add("grid--2-col-desktop");
productGrid.classList.remove("grid--4-col-desktop");
} 
else{
productGrid.classList.add("grid--4-col-desktop");
productGrid.classList.remove("grid--2-col-desktop");
}
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        } else {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc + '?sort_by=' + sortOption;
            fetch(window.location.pathname + '?section_id=' + sectionid + '&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
                var endlessScroll = new Ajaxinate({
                container: '#product-grid',
                pagination: '#AjaxinatePagination',
                method: 'scroll',
                offset: 1000
                });
                  var data_handle = document.querySelector(".switch_layout_inner.active").getAttribute("data-handle");
var productGrid = document.getElementById("product-grid");
if (data_handle == 'listed') {
productGrid.classList.add("grid--2-col-desktop");
productGrid.classList.remove("grid--4-col-desktop");
} 
else{
productGrid.classList.add("grid--4-col-desktop");
productGrid.classList.remove("grid--2-col-desktop");
}
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        }
    }
});
// Select all elements with class "sort-custom-icon" and attach a click event listener
document.querySelectorAll(".sort-custom-icon").forEach(function(element) {
    element.addEventListener("click", function() {
        // Toggle the class "mob-sort-active" on the parent element with class "custom-sort_by_filter"
        var parentElement = this.closest(".custom-sort_by_filter");
        if (parentElement) {
            parentElement.classList.toggle("mob-sort-active");
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    offset: 1000
    });
     // Collection page cross icon js in filter desktop 
    const closeButton = document.querySelector('.desktop-facets__close');
    const mobileFacetsDisclosure = document.querySelector('.mobile-facets__disclosure.disclosure-has-popup');

    if (closeButton && mobileFacetsDisclosure) {
        closeButton.addEventListener('click', function() {
        
        mobileFacetsDisclosure.classList.remove('menu-opening');
        mobileFacetsDisclosure.removeAttribute('open');
        document.body.classList.remove('filteropen');
        });
    }
});
document.addEventListener("click", function(event) {
    var summaryElements = document.querySelectorAll(".mobile-facets__summary");
    summaryElements.forEach(function(summary) {
        if (event.target === summary || summary.contains(event.target)) {
            var details = summary.closest(".mobile-facets__details");
            if (details) {
                details.classList.toggle("openmobile-filter");
            }
        }
    });
});


document.addEventListener("click", function(event) {
    // Check if the clicked element matches the selector
    if (event.target.matches(".mobile_filter_cross span.mobile-facets__close svg")) {
      
        // Remove classes from body
        document.body.classList.remove('filteropen', 'overflow-hidden-mobile');
        
        // Remove classes and attributes from elements
        var disclosureElements = document.querySelectorAll(".mobile-facets__disclosure");
        disclosureElements.forEach(function(element) {
            element.classList.remove("menu-opening");
            element.removeAttribute("open");
        });
    }
});